import { createContext, useContext } from "react"
import type { VoiceCallRecord } from "@/types/v2/voice"

// Lets a deeply-nested voice-call message bubble open the
// full-transcript study surface (desktop rail / mobile
// overlay) without prop-drilling through ChatPanel →
// MessageTranscript → MessageBubble. The inbox page owns the
// open-call state and provides this; the rail/overlay it
// renders lives at the page level (it overlays the
// ContextPane on desktop), per "lift shared state to the
// page".
export interface TranscriptViewerContextValue {
  // The call currently open in the rail/overlay, or null.
  // The bubble reads this to swap its "View AI transcript"
  // toggle for a "Transcribed by AI" status when its call is
  // already open in the rail (Paper 14NY-0).
  activeCallId: number | null
  openTranscript: (call: VoiceCallRecord) => void
  close: () => void
}

export const TranscriptViewerContext =
  createContext<TranscriptViewerContextValue | null>(null)

// Returns null when no provider is mounted (e.g. an isolated
// component test) so callers can degrade gracefully.
export function useTranscriptViewer(): TranscriptViewerContextValue | null {
  return useContext(TranscriptViewerContext)
}
